import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f7f4404"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  for: "props.idDrop"
}
const _hoisted_2 = {
  key: 0,
  id: "props.idDrop"
}
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = ["id", "size", "default-option", "selected-option", "state", "helper"]

import { computed, onMounted, PropType } from 'vue';
import { OptionDrop } from '../../types/types';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSddsDropdownFilter',
  props: {
  idDrop: {
    type: String,
    default: null,
    required: true,
  },
  selection: {
    type: String,
    default: null,
  },
  options: {
    type: Array as PropType<Array<OptionDrop>>,
    default: () => [],
  },
  size: {
    type: String,
    default: 'Large',
  },
  labelDescription: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:selection'],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line


const selectedValue = computed(() => (props.selection));

const isThereALabel = computed(() => (props.labelDescription.length > 0));

const isShowMessageRequired = computed(() => (!!(props.required && (selectedValue.value ?? '*') === '*')));

const getMessageHelper = computed(() => (props.required && (selectedValue.value ?? '*') === '*' ? 'Field Required' : null));

function handleSelectOption(event: Event) {
  // console.log('handleSelectOption: ', event);
  emit('update:selection', { keyDropdown: props.idDrop, value: event.detail.value });
}

onMounted(() => {
  if (props.idDrop) {
    // console.log('props.idDrop: ', props.idDrop);
    const dropdownElement = document.getElementById(props.idDrop);
    dropdownElement?.addEventListener('selectOption', handleSelectOption);
    var data = [];
    props.options.forEach(item => {
      data.push({ value: item.key, label: item.value });
    });
    if (dropdownElement){
      dropdownElement.data = JSON.stringify(data);
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isThereALabel))
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.labelDescription) + " ", 1),
          false
            ? (_openBlock(), _createElementBlock("input", _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("sdds-dropdown-filter", {
        id: props.idDrop,
        placeholder: "Select option",
        label: "Label text",
        size: __props.size,
        "default-option": _unref(selectedValue),
        "selected-option": _unref(selectedValue),
        state: _unref(isShowMessageRequired) ? 'error' : '',
        helper: _unref(getMessageHelper)
      }, null, 8, _hoisted_4)
    ])
  ], 64))
}
}

})